import { useContext } from 'react';
import { Grid, Container, Button, CircularProgress } from '@material-ui/core';
import { Page } from 'components';
import { bulkEditContext } from './BulkEditContext';
import { Assignee, CSAssignee, TicketTypology, TicketStatus, Reporter } from './components';


let BulkEdit = () => {
    let { bulkEditRequest, isLoading, isSaving, updateRequest, doBulkEdit } = useContext(bulkEditContext);


    return (
        <Container maxWidth="md">
            <Page
                useHeader={true}
                isLoading={isLoading}
                title={"Edit in bulk"}
                subtitle={`You're about to edit ${bulkEditRequest.numberOfItems} claims`}
            >
                <Grid container>
                    <Reporter request={bulkEditRequest} updateRequest={updateRequest} />
                </Grid>
                <Grid container>
                    <Assignee request={bulkEditRequest} updateRequest={updateRequest} />
                </Grid>
                <Grid container>
                    <CSAssignee request={bulkEditRequest} updateRequest={updateRequest} />
                </Grid>
                <Grid container>
                    <TicketStatus request={bulkEditRequest} updateRequest={updateRequest} />
                </Grid>
                <Grid container>
                    <TicketTypology request={bulkEditRequest} updateRequest={updateRequest} />
                </Grid>

                <Grid container>
                    <Grid item xs />
                    <Grid item>
                        <Button
                            color="secondary"
                            disabled={isSaving}
                            onClick={() => doBulkEdit(bulkEditRequest)}
                            variant='contained'
                        >
                            {isSaving && <><CircularProgress size={16} />&nbsp;</>}Confirm
                        </Button>
                    </Grid>
                </Grid>
            </Page>
        </Container>
    )
}

export default BulkEdit;